import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { CoreModule } from 'app/core/core.module';
import { StudentList } from '../../../../models/StudentList';
import { User } from '../../../../models/User';
import { FeatureFlagService, FLAGS } from '../../../../services/feature-flag.service';

@Component({
	standalone: true,
	imports: [CommonModule, CoreModule],
	selector: 'app-selection',
	templateUrl: './selection.component.html',
	styleUrls: ['./selection.component.scss'],
})
export class SelectionComponent implements OnInit {
	@Input() selection!: StudentList | User;
	@Input() locked = false;
	@Input() showIcon = true;
	@Input() isUser!: boolean;
	@Input() tooltipContent?: TemplateRef<unknown>;

	@Output() removeSelectionEvent: EventEmitter<StudentList | User> = new EventEmitter<StudentList | User>();

	constructor(private featureFlags: FeatureFlagService) {}

	hovered = false;
	iconHovered = false;
	hasSchedulesFF = false;
	studentList: StudentList | null = null;
	student: User | null = null;

	ngOnInit(): void {
		this.hasSchedulesFF = this.featureFlags.isFeatureEnabledV2(FLAGS.Schedules);
		if (this.isUser) {
			this.student = this.selection as User;
		} else {
			this.studentList = this.selection as StudentList;
		}
	}

	removeSelection(selection: StudentList | User): void {
		if (!this.locked) {
			this.removeSelectionEvent.emit(selection);
		}
	}
}
